import React, { useMemo, useState } from "react";
import CibilReports from "../cibilReport";
import CkycekycReport from "../ckycekycReport/index";
import SMSandEMAILLogs from "../ccmSMSandEMAILlogs";
import PAN_INSTA_REPORT from "../../components/Downloads/PAN_InstaReport/index";
import PolicyReport from "../../components/Downloads/PolicyReport";
import IVCReport from "../../components/Downloads/IvcReport/index";
import { hasPermission } from "../../components/Permissions";
import UpfrontPaymentReport from "../UpfrontPaymentReport";
import AuditTrailReport from "../AuditTrailReport/index.js";
const Report = () => {
  const tabs = useMemo(() => {
    const items = [
      {
        key: "CIBIL",
        label: "Cibil Reports",
        Component: () => <CibilReports embedded />,
      },
      {
        key: "EKYC_CKYC",
        label: "EKYC / CKYC",
        Component: () => <CkycekycReport embedded />,
      },
      {
        key: "CCM_LOGS",
        label: "CCM SMS & Email",
        Component: () => <SMSandEMAILLogs embedded />,
      },
      { key: "PAN_INSTA", label: "PAN Insta", Component: PAN_INSTA_REPORT },
      { key: "POLICY", label: "Policy Report", Component: PolicyReport },
      { key: "IVC", label: "IVC Report", Component: IVCReport },
    ];

    if (window.envType === "DEV") {
      items.unshift({
        key: "Audit_Trail",
        label: "Journey Selection Audit Report",
        Component: AuditTrailReport,
      });
    }

    if (hasPermission("UPFRONT_PAYMENT_REPORT")) {
      items.push({
        key: "UPFRONT",
        label: "Upfront Payment",
        Component: UpfrontPaymentReport,
      });
    }

    return items;
  }, []);

  const [activeTab, setActiveTab] = useState(() => tabs[0]?.key || "CIBIL");

  const activeItem = tabs.find((tab) => tab.key === activeTab) || tabs[0];
  const ActiveComponent = activeItem?.Component;

  const renderTab = (tab) => {
    const isSelected = activeTab === tab.key;

    return (
      <div
        key={tab.key}
        role="button"
        tabIndex={0}
        onClick={() => setActiveTab(tab.key)}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            setActiveTab(tab.key);
          }
        }}
        className={`view-count proposal-dashboard__filter-card reports-page__tab ${
          isSelected ? "selected" : ""
        }`}
      >
        <span className="proposal-dashboard__filter-label">{tab.label}</span>
      </div>
    );
  };

  return (
    <div className="proposal-dashboard reports-page">
      <div className="proposal-dashboard__header reports-page__header">
        <h2 className="proposal-dashboard__title">Reports</h2>
        <p className="proposal-dashboard__subtitle">
          View and export operational, compliance, and payment reports
        </p>
      </div>

      <div className="view-options proposal-dashboard__filters reports-page__tabs">
        {tabs.map(renderTab)}
      </div>

      <div className="reports-page__content">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};

export default Report;
